import { render, staticRenderFns } from "./ProductDiscountComponent.vue?vue&type=template&id=f7a833a0&scoped=true"
import script from "./ProductDiscountComponent.vue?vue&type=script&lang=js"
export * from "./ProductDiscountComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a833a0",
  null
  
)

export default component.exports